import {create} from "zustand";
import {useShallow} from "zustand/react/shallow";
import {modalTypes} from "../types/modal";

type actionsTypes = {
    actions: {
        showModal: ({title, maxWidth, children, isCloseButton}: Pick<modalTypes, 'children' | 'title' | 'maxWidth' | 'isCloseButton'>) => void,
        closeModal: () => void,
    }
}

const useStoreModalCreate = create<modalTypes & actionsTypes>((set) => ({
    show: false,
    isCloseButton: false,
    actions: {
        showModal: ({title, maxWidth, children, isCloseButton}) => set((state) => ({...state, show: true, title, maxWidth, children, isCloseButton})),
        closeModal: () => set((state) => ({...state, show: false, title: '', maxWidth: '', children: ''})),
    },
}));

export const useStoreModal = () => useStoreModalCreate(useShallow((state) => state.actions));
export const useStoreModalValue = () => useStoreModalCreate(useShallow((state) => state));
